import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "./home.css";
import tixbook_white from "../../assets/images/Tixbook_logo_white.png";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from "split-type";
import EventsSection from "../../components/eventCards/EventsSection";
import BannerAds from "../../components/bannerAds/bannerAds"
import AdsSection from "../../components/adsSection/adsSection";
import ExploreCities from "../../components/exploreCities/exploreCities";

gsap.registerPlugin(ScrollTrigger);

function Home() {
  const linesRef = useRef([]);
  const textRef = useRef(null);

  const slides = [
    { className: "banner-1", text: ["Book your next unforgettable ", "event in seconds with Tixbook!"] },
    { className: "banner-2", text: ["Discover amazing events,", "Book your tickets now!"] },
    { className: "banner-3", text: ["Experience unforgettable moments,", "Join us today!"] },
  ];

  useLayoutEffect(() => {
    const animateText = (index) => {
      const lines = linesRef.current[index] || [];
      gsap.set(lines, { y: "100%" });

      gsap.to(lines, {
        y: "0%",
        duration: 1.2,
        ease: "power4.out",
        stagger: 0.3,
        overwrite: true,
      });
    };

    const swiper = document.querySelector(".swiper-container")?.swiper;
    if (swiper) {
      animateText(0);
      swiper.on("slideChange", () => {
        animateText(swiper.activeIndex);
      });
    }

    const text = new SplitType(textRef.current, { type: "words, chars" });

    gsap.from(text.chars, {
      opacity: 0,
      y: 30, // Reduce vertical movement for a snappier effect
      rotateX: -60, // Reduce rotation for faster movement
      stagger: 0.02, // Reduce delay between each character
      duration: 0.6, // Reduce total animation duration
      ease: "power2.out", 
      scrollTrigger: {
        trigger: textRef.current,
        start: "top 85%",
        toggleActions: "play none none none",
      },
    });
    

    return () => text.revert();

  }, []);

  return (
    <><section className="homeBannerWrapper container">
      <Swiper
        modules={[Autoplay, EffectFade, Pagination]}
        effect="fade"
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop={true}
        pagination={{ clickable: true }}
        className="swiper-container"
        breakpoints={{
          320: { slidesPerView: 1 }, 
          768: { slidesPerView: 1 }, 
          1024: { slidesPerView: 1 }, 
          1200: { slidesPerView: 1 }, 
        }}
      >
        {slides.map((slide, slideIndex) => (
          <SwiperSlide key={slideIndex}>
            <div className={`homebanner ${slide.className} py-md-5 my-md-5 position-relative`}>
              <div className="overlay-bg"></div>
              <div className="animation-section style-5">
                <div className="reveal-wrapper">
                  <h1>
                    {slide.text.map((text, index) => (
                      <span className="line" key={index}>
                        <span
                          className="line-inner"
                          ref={(el) => {
                            if (el) {
                              if (!linesRef.current[slideIndex]) linesRef.current[slideIndex] = [];
                              linesRef.current[slideIndex][index] = el;
                            }
                          } }
                        >
                          {text}
                        </span>
                      </span>
                    ))}
                  </h1>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
    
    <section className="container my-5">
            <div className="row align-items-center justify-content-center adBanner py-5 mx-0">
            <div className="col-md-2 offset-md-1">
                    <img src={tixbook_white} alt="Ad Banner" className="img-fluid" />
                  </div>
                  <div className="col-md-9 text-center">
                    <h2 ref={textRef} className="text-white mb-0" style={{fontSize: '1.5rem'}}>
                    Your gateway to concerts, shows & events across UK – Book now!
                    </h2>
                  </div>
            </div>
    </section>

    <section className="container my-5">
      <EventsSection title="Upcoming Events" />
    </section>

    <section className="container my-5 d-none">
      <BannerAds/>
    </section>

    <section className="container my-5 d-none">
      <EventsSection title="Featured Shows" />
    </section>

    {/* <AdsSection/> */}

    <section className="container my-5 d-none">
      <ExploreCities/>
    </section>
    
      
  </>
  );
}

export default Home;
